import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import * as Util from "@/functions/Util";

export default class PrecoValidation extends DefaultValidation {

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs, tabpreco) {
        let validated = true;
        
        if (!this._validateInputs(tabpreco, true)) {
            refs.idTabelaPreco.focusedOut = true;
            validated = false;
        }

        if (!this._validateInputs(model.valorunitario)) {
            refs.valorunitarioInput.focusedOut = true;
            validated = false;
        }

        if (!this._validateInputs(model.valor1)) {
            refs.valor1Input.focusedOut = true;
            validated = false;
        }

        if (!this._validateInputs(model.valorminimo)||model.valorminimo>model.valor1) {
            refs.valorminimoInput.focusedOut = true;
            validated = false;
        }

        if (!this._validateInputs(model.valormaximo)||model.valormaximo<model.valor1) {
            refs.valormaximoInput.focusedOut = true;
            validated = false;
        }

        if (!this._validateInputs(model.descmaximo1)) {
            refs.descmaximo1Input.focusedOut = true;
            validated = false;
        }

        if (!this._validateInputs(model.custoproduto)) {
            refs.custoprodutoInput.focusedOut = true;
            validated = false;
        }
        
        if (!this._validateInputs(model.datamaxima)) {
            refs.datamaximaInput.focusedOut = true;
            validated = false;
        }

        if (!this._validateInputs(model.liberaalteracao, true)) {
            refs.liberaalteracaoInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }

    _validateInputs(value, isSelect = false, isCliente = false) {
        if (isSelect && !isCliente && value == 0) {
            return false;
        }

        if (value == null) {
            return false;
        } else if (typeof value === 'string' && value !== '0' && !value.trim()) {
            return false;
        }

        return true;
    }

    _validatePorcentagem(value) {
        let validate = false;

        validate = this._validateInputs(value) && !Util.validatePorcentagem(value);

        return validate;
    }
}